<script>

import i18n from "../i18n";
import {mapActions, mapGetters} from 'vuex'

/**
 * Nav-bar Component
 */
export default {
  data() {
    return {
      languages: [
        {
          flag: require("@/assets/images/flags/us.jpg"),
          language: "en",
          title: "English",
        },
        {
          flag: require("@/assets/images/flags/chaina.png"),
          language: "zh",
          title: "Chinese",
        },
      ],
      lan: i18n.locale,
      text: null,
      flag: null,
      value: null,
      myVar: 1,
      localTime: '',
      currentTime: ''
    };
  },
  components: { },
  mounted() {
    this.value = this.languages.find((x) => x.language === i18n.locale);
    this.text = this.value.title;
    this.flag = this.value.flag;
  },
  methods: {
    ... mapActions({
      logoutUser: 'authentication/logoutUser'
    }),
    toggleMenu() {
      this.$parent.toggleMenu();
    },
    initFullScreen() {
      document.body.classList.toggle("fullscreen-enable");
      if (
        !document.fullscreenElement &&
        /* alternative standard method */ !document.mozFullScreenElement &&
        !document.webkitFullscreenElement
      ) {
        // current working methods
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen(
            Element.ALLOW_KEYBOARD_INPUT
          );
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    },
    setLanguage(locale, country, flag) {
      this.lan = locale;
      this.text = country;
      this.flag = flag;
      i18n.locale = locale;
    },
    refreshPage(){
      this.$router.go()
    },
    logoutFn(){
      this.logoutUser()
    }

  },
  computed: {
    ... mapGetters({
      activeUser: 'authentication/activeUser'
    }),
    avatar(){
      return JSON.parse(localStorage.getItem('activeUser'))
    }
  },
};
</script>

<template>
  <header id="page-topbar">
    <div class="navbar-header">
      <div class="d-flex">
        <!-- LOGO -->
        <div class="navbar-brand-box">
          <router-link to="/" class="logo logo-light">
            <span class="logo-sm">
              <img src="@/assets/images/FullKikkomanLogo.png" height="25" alt />
            </span>
            <span class="logo-lg">
              <img src="@/assets/images/KikkomanNameLogo.png" alt height="30" />
            </span>
          </router-link>
        </div>

        <button
          id="vertical-menu-btn"
          type="button"
          class="btn btn-sm px-3 font-size-16 header-item"
          @click="toggleMenu"
        >
          <i class="fa fa-fw fa-bars"></i>
        </button>

      </div>

      <div class="d-flex">

        <!--        logout button-->
        <div class="dropdown d-inline-block">
          <button
              type="button"
              @click="refreshPage"
              class="btn header-item noti-icon right-bar-toggle toggle-right"
          >
            <i class="bx bx-sync toggle-right text-danger"></i>
          </button>
        </div>

        <!--        language change-->
<!--        <b-dropdown variant="white" right toggle-class="header-item">-->
<!--          <template v-slot:button-content>-->
<!--            <img class :src="flag" alt="Header Language" height="16" />-->
<!--            {{ text }}-->
<!--          </template>-->
<!--          <b-dropdown-item-->
<!--              class="notify-item"-->
<!--              v-for="(entry, i) in languages"-->
<!--              :key="`Lang${i}`"-->
<!--              :value="entry"-->
<!--              @click="setLanguage(entry.language, entry.title, entry.flag)"-->
<!--              :class="{ active: lan === entry.language }"-->
<!--          >-->
<!--            <img-->
<!--                :src="`${entry.flag}`"-->
<!--                alt="user-image"-->
<!--                class="me-1"-->
<!--                height="12"-->
<!--            />-->
<!--            <span class="align-middle">{{ entry.title }}</span>-->
<!--          </b-dropdown-item>-->
<!--        </b-dropdown>-->

<!--        user profile-->
        <b-dropdown
            right
            variant="black"
            toggle-class="header-item"
            menu-class="dropdown-menu-end"
        >
          <template v-slot:button-content>
            <img
                class="rounded-circle header-profile-user"
                :src="avatar.avatar"
                alt="Header Avatar"
            />
            <span class="d-none d-xl-inline-block ms-1">
              <div>
               {{activeUser.firstName}} {{activeUser.lastName}}
              </div>
              </span
              >
            <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
          </template>
          <!-- item-->
          <b-dropdown-item>
            <router-link to="/profile">
              <i class="bx bx-user font-size-16 align-middle me-1"></i>
              {{ $t("navbar.dropdown.henry.list.profile") }}
            </router-link>
          </b-dropdown-item>
          <b-dropdown-divider></b-dropdown-divider>
          <p @click="logoutFn" class="dropdown-item text-danger">
            <i
                class="bx bx-power-off font-size-16 align-middle me-1 text-danger"
            ></i>
            {{ $t("navbar.dropdown.henry.list.logout") }}
          </p>
        </b-dropdown>

        <!--        fullscreen button-->
        <div class="dropdown d-none d-lg-inline-block ms-1">
          <button
              type="button"
              class="btn header-item noti-icon"
              @click="initFullScreen"
          >
            <i class="bx bx-fullscreen"></i>
          </button>
        </div>


      </div>
    </div>
  </header>
</template>
